import { DataTableColumnCell } from '@/components/ui/data-table/DataTableColumnCell'

// TODO: this file and rank badge as same component, need to refactor
// Array of color style objects
const colorStyles = [
  { bg: 'bg-blue-50', text: 'text-blue-600', border: 'border-blue-100' },
  { bg: 'bg-green-50', text: 'text-green-700', border: 'border-green-100' },
  { bg: 'bg-red-50', text: 'text-red-600', border: 'border-red-100' },
  { bg: 'bg-gray-50', text: 'text-gray-700', border: 'border-gray-100' },
  { bg: 'bg-yellow-50', text: 'text-yellow-700', border: 'border-yellow-100' },
  { bg: 'bg-lime-50', text: 'text-green-900', border: 'border-lime-100' },
]

// Hash function to map string to a color index
function hashStringToIndex(str: string, max: number) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return Math.abs(hash) % max
}

// Props: same as DataTableColumnCell
export function ScalrBadge(props: any) {
  const value = props.row.getValue(props.accessorKey)
  const idx = hashStringToIndex(String(value), colorStyles.length)
  const style = colorStyles[idx]

  return (
    <DataTableColumnCell
      {...props}
      className={
        `inline-block p-2 rounded-md text-sm border ${style.bg} ${style.text} ${style.border}` +
        (props.className || '')
      }
    >
      {value}
    </DataTableColumnCell>
  )
}

export default ScalrBadge
